var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('header-cool'),_c('mdb-row',{staticClass:"justify-content-md-center menu-bar-color",attrs:{"fluid":""}},[_c('mdb-col',{staticClass:"space-down",attrs:{"sm":"10"}},[_c('main-menu')],1)],1),_c('body-content'),_c('footer-cool')],1)}
var staticRenderFns = []

export { render, staticRenderFns }